var isSupported;
/**
 * Returns whether passive event listeners are supported.
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 */

export default function isPassiveEventListenerSupported() {
  if (isSupported != null) {
    return isSupported;
  }

  isSupported = false;

  function noop() {}

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        isSupported = true;
        return isSupported;
      }
    });
    window.addEventListener('test', noop, options);
    window.removeEventListener('test', noop, options);
  } catch (error) {} // eslint-disable-line no-empty


  return isSupported;
}
//# sourceMappingURL=isPassiveEventListenerSupported.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/isPassiveEventListenerSupported.js
// module id = 198
// module chunks = 0 1